<template>
    <e-charts  :options='option' class="echarts"   />
</template>


<script>
import ECharts from 'vue-echarts'
import { use } from 'echarts/core'
import { TitleComponent } from 'echarts/components';
// import ECharts modules manually to reduce bundle size
import {
    CanvasRenderer
} from 'echarts/renderers'
import {
   LineChart
} from 'echarts/charts'
import {
    GridComponent,
    TooltipComponent

} from 'echarts/components'

use([
    CanvasRenderer,
    LineChart,
    GridComponent,
    TooltipComponent,
    TitleComponent
]);

export default {
    name: "ChartCard",
    components: {
        ECharts
    },
    data(){
        return{
            option: {
                //title: {
                    //text: 'Hóteis Cadastrados por Mês'
                //},
                tooltip: {
                    trigger: 'axis',
                    formatter: 'Hotéis cadastrados: <br/>{b} : {c}'
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: [] ,
                    type: 'line',
                    smooth: true
                }],

            }
        }
    },
    mounted() {
        axios.get(`/api/dashboard/graphics`)
            .then(res => {
                this.option.xAxis.data = Object.keys(res.data.hotelsEvolution)
                const g = [];
                Object.keys(res.data.hotelsEvolution).map(key => {
                    g.push(res.data.hotelsEvolution[key])
                } )
                this.option.series[0].data = g
            })
    },
}


</script>

<style scoped>
.echarts{
    height:610px;
    width: auto;
}
</style>
